import React from 'react';
import styled from 'styled-components';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { COLORS } from '../../../app/common/constants/styles';

const WarningArea = styled.div`
    margin: 24px auto;
`;

const SendOtplimitMsg: React.FC = () => {
    return (
        <>
            <WarningArea>
                {TranslationHelpers.getFormattedMessage('email.verify.sendLimit')}
            </WarningArea>
            <WarningArea>
                {TranslationHelpers.getFormattedMessage('email.verify.sendLimit_two')}
            </WarningArea>
        </>
    );
};

export default SendOtplimitMsg;
